import { deserialize, serializable } from 'serializr';
import { Base } from './base.model';
import { PageObject } from './page-object.model';
import { RoleType } from '@enums/role-type.enum';

export class Role extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public description: string;

  get isSuperAdmin() {
    return this.name == RoleType.Super_Administrator;
  }

  get isAgent() {
    return this.name == RoleType.Agent;
  }

  get isTestManager() {
    return this.name == RoleType.Test_Manager;
  }

  get isAutomationEngineerOrDeveloper() {
    return this.name == RoleType.Automation_Engineer;
  }

  get isTestLead() {
    return this.name == RoleType.Test_Lead;
  }

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Role, input));
  }
}
